function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useRef, useEffect, useState, useLayoutEffect, forwardRef, useImperativeHandle } from 'react';
import PropTypes from 'prop-types';
import { loader } from './styles';
import { jsx as ___EmotionJSX } from "@emotion/react";
var Spinner = /*#__PURE__*/forwardRef(function (props, reference) {
  var _props$size = props.size,
      sizeProp = _props$size === void 0 ? 50 : _props$size,
      _props$loading = props.loading,
      loading = _props$loading === void 0 ? false : _props$loading,
      fullScreen = props.fullScreen,
      className = props.className;

  var _useState = useState(sizeProp),
      _useState2 = _slicedToArray(_useState, 2),
      size = _useState2[0],
      setSize = _useState2[1];

  var _useState3 = useState(loading),
      _useState4 = _slicedToArray(_useState3, 2),
      isLoading = _useState4[0],
      setIsLoading = _useState4[1];

  var loaderRef = useRef(null);
  useImperativeHandle(reference, function () {
    return {
      showLoading: function showLoading() {
        return setIsLoading(true);
      },
      hideLoading: function hideLoading() {
        return setIsLoading(false);
      },
      changeSize: function changeSize(newSize) {
        return setSize(newSize);
      }
    };
  });
  useLayoutEffect(function () {
    var container = loaderRef.current.parentNode;

    var _container$getBoundin = container.getBoundingClientRect(),
        height = _container$getBoundin.height,
        width = _container$getBoundin.width;

    if (height === 0 || width === 0) return; // If the component is smaller than the default size set the size to half of component size

    if (height / 2 < size || width / 2 < size) setSize(Math.min(height, width) / 2);
  }, []);
  useEffect(function () {
    var _loaderRef$current;

    loaderRef.current && toggleLoader(isLoading);
    isLoading && !fullScreen && ((_loaderRef$current = loaderRef.current) === null || _loaderRef$current === void 0 ? void 0 : _loaderRef$current.parentNode) && setUpPosition();
    return function () {
      loaderRef.current && toggleLoader(false);
      window.removeEventListener('scroll', handleScroll);
    };
  }, [isLoading]);
  useEffect(function () {
    sizeProp !== size && setSize(sizeProp);
    loading !== isLoading && setIsLoading(loading);
  }, [sizeProp, loading]);

  var setUpPosition = function setUpPosition() {
    var container = loaderRef.current.parentNode;

    var _container$getBoundin2 = container.getBoundingClientRect(),
        top = _container$getBoundin2.top,
        bottom = _container$getBoundin2.bottom;

    var windowHeight = window.innerHeight; // If the component to which the loader will be applied is bigger than the window height
    // we need to put the spinner into the middle of the screen so the user can see it even when scroll

    if (top < windowHeight && bottom > windowHeight) {
      loaderRef.current.style.top = "".concat(windowHeight / 2 - top - size / 2, "px"); // Listen for changes into the scroll and place the loader into the middle of the screen

      window.addEventListener('scroll', handleScroll);
    }
  };

  var handleScroll = function handleScroll() {
    var _loaderRef$current2;

    if (!((_loaderRef$current2 = loaderRef.current) !== null && _loaderRef$current2 !== void 0 && _loaderRef$current2.parentNode)) window.removeEventListener('scroll', handleScroll);else {
      var parentNode = loaderRef.current.parentNode;
      var windowHeight = window.innerHeight;

      var _parentNode$getBoundi = parentNode.getBoundingClientRect(),
          top = _parentNode$getBoundi.top;

      loaderRef.current.style.top = "".concat(windowHeight / 2 - top - size / 2, "px");
    }
  };

  var toggleLoader = function toggleLoader(show) {
    var _loaderRef$current3 = loaderRef.current,
        parentNode = _loaderRef$current3.parentNode,
        loaderStyles = _loaderRef$current3.style;
    var parentStyles = parentNode.style,
        childNodes = parentNode.childNodes;
    parentStyles.position = show ? 'relative' : '';
    parentStyles.pointerEvents = show ? 'none' : '';
    loaderStyles.display = show ? 'block' : 'none'; // If there is only the loader inside the parent exit from function

    if (childNodes.length === 1) return;
    show ? wrapChilds() : unwrapChilds();
  }; // Put all childrens into container with blur effect and no pointer events so it will be disabled


  var wrapChilds = function wrapChilds() {
    var parentNode = loaderRef.current.parentNode;
    var childNodes = parentNode.childNodes;
    var blurContainer = document.createElement('div');
    blurContainer.style.filter = 'blur(3px)';
    blurContainer.id = 'blurContainer';
    className && blurContainer.classList.add(className);
    parentNode.insertBefore(blurContainer, loaderRef.current);

    var validChilds = _toConsumableArray(childNodes);

    validChilds.forEach(function (child) {
      return !child.isSameNode(loaderRef.current) && !child.isSameNode(blurContainer) && blurContainer.appendChild(child);
    });
  };

  var unwrapChilds = function unwrapChilds() {
    var parentNode = loaderRef.current.parentNode;
    var childNodes = parentNode.childNodes;
    var blurContainer = childNodes.item(_toConsumableArray(childNodes).findIndex(function (el) {
      return el.getAttribute && el.getAttribute('id') === 'blurContainer';
    }));
    if (!blurContainer) return;

    _toConsumableArray(blurContainer.childNodes).forEach(function (el) {
      return parentNode.appendChild(el);
    });

    parentNode.removeChild(blurContainer);
  };

  return ___EmotionJSX("svg", {
    ref: loaderRef,
    css: loader(size, props),
    viewBox: "0 0 50 50",
    className: "spinner"
  }, ___EmotionJSX("circle", {
    className: "path",
    cx: "25",
    cy: "25",
    r: "20",
    fill: "none",
    strokeWidth: "5"
  }));
});
Spinner.propTypes = {
  size: PropTypes.number,
  loading: PropTypes.bool,
  fullScreen: PropTypes.bool,
  className: PropTypes.string
};
export default Spinner;